import React, { useMemo, useEffect, useState } from 'react'
import { Icon, Modal, Select, Tooltip } from 'antd'
import i18n from 'i18next'
import Flag from 'react-world-flags'
import { withTranslation } from 'react-i18next'

import { Logo } from '..'
// import { Header } from './styled'
import './style.scss'

import { config, languages } from '../../constants'
import { Profile, Informations } from './internal'

import chatbotIcon from './images/new_sharebot.svg'
import assistanceIcon from '../ShareAssistance/assets/assistance_new.jpg'
import userDummyIcon from './images/user.svg'
import history from '../../history'
import { useDispatch, useSelector } from 'react-redux'

import actions from '../../store/actions'
import SharelookHelpModal from './SharelookHelpModal/SharelookHelpModal'

const { Option } = Select

const pathname = window.location.pathname

function NewHeaderMain(props) {
  const [showInfoModal, setShowInfoModal] = useState(false)
  const [lang, setLang] = useState('en-us')
  const [showMenu, setShowMenu] = useState(false)
  const [isShowingKnowledgeCenter, setIsShowingKnowledgeCenter] = useState(
    false
  )

  const [isJustSignedIn, setIsJustSignedIn] = useState(true)

  const shareBot = useSelector(state => state.sharebot)
  const dispatch = useDispatch()

  useEffect(() => {
    handleLanguage()
  }, [])

  useEffect(() => {
    setIsJustSignedIn(props.user.isLogin)
  }, [props.user])

  useEffect(() => {
    setIsJustSignedIn(false)
    setIsShowingKnowledgeCenter(pathname.includes('/knowledge-center'))
  }, [pathname])

  const handleLanguage = () => {
    if (localStorage.getItem('i18nextLng') === 'en-US') {
      localStorage.setItem('i18nextLng', 'english')
    }
    const lang = localStorage.getItem('i18nextLng') || 'en-us'

    if (checkHebrewArabic(lang)) {
      document.body.style.direction = 'rtl'
      document.body.className = 'shl-rtl'
    } else {
      document.body.style.direction = 'ltr'
    }

    setLang(lang)
  }

  const toggleInfoModal = () => setShowInfoModal(val => !val)

  const toggleAssistance = () => {
    const { showAssistance } = shareBot
    if (showAssistance) {
      dispatch(actions.sharebot.disableAssistance())
    } else {
      dispatch(actions.sharebot.enableAssistance())
    }
  }
  const toggleBot = () => {
    const { showShareBot } = shareBot
    if (showShareBot) {
      dispatch(actions.sharebot.disableShareBot())
    } else {
      dispatch(actions.sharebot.enableShareBot())
    }
  }

  const handleChangeOption = async e => {
    if (checkHebrewArabic(e) || checkHebrewArabic(lang)) {
      window.location.reload()
    }
    setLang(e)
    i18n.changeLanguage(e)
  }

  const checkHebrewArabic = someLang =>
    someLang === 'hebrew' || someLang === 'arabic'

  const { user, updateUser, organizations, t } = props

  const { headerLogo, headerColor } = useMemo(() => {
    const userImage =
      (user && user.info.avatar && user.info.avatar.resizes.thumbnail) ||
      userDummyIcon
    const activeOrgInfo =
      organizations &&
      organizations.rows &&
      organizations.rows.find(
        org => user && user.info.active_organization_id === org.id
      )
    const isOrgWhiteLabelEnabeld =
      activeOrgInfo && activeOrgInfo.enable_white_label

    const orgHasWhiteLabelData =
      isOrgWhiteLabelEnabeld && activeOrgInfo && activeOrgInfo.white_label_data
    const headerInfo = orgHasWhiteLabelData && orgHasWhiteLabelData.header
    const headerColor = headerInfo && headerInfo.color
    const headerLogo = headerInfo && headerInfo.logo && headerInfo.logo.link

    const languageSelect = document.getElementById('language_select')

    const selectElement =
      languageSelect && languageSelect.querySelector('.ant-select-selection')

    if (selectElement && headerColor)
      selectElement.style.backgroundColor = headerColor
    else if (selectElement && !headerColor)
      selectElement.style.backgroundColor = '#333333'

    return { userImage, headerLogo, headerColor }
  }, [user, organizations])

  const handleToggleCenter = () => {
    if (isShowingKnowledgeCenter) {
      history.push('/training')
    } else {
      history.push('/knowledge-center')
    }
  }

  // check if dev env or prod
  const isDev = process.env.NODE_ENV === 'development'
  return (
    <>
      <div color={headerColor} className="main_header">
        <div className="main-herader-inner">
          <div className="main-herader-inner">
            <SharelookHelpModal />
            {!isShowingKnowledgeCenter &&
              ((user &&
                user.info &&
                (user.info.active_organization_id === 519 ||
                  user.info.active_organization_id === 533 ||
                  user.info.active_organization_id === 459 || user.info.active_organization_id === 544 || user.info.active_organization_id === 96)) ||
                isDev) && (
                <Tooltip title={t('v4:sharelook_assistance')}>
                  <div className="assistance_button" onClick={toggleAssistance}>
                    <img alt="" src={assistanceIcon} />
                  </div>
                </Tooltip>
              )}
            {!isShowingKnowledgeCenter && (
              <Tooltip title={t('v4:sharebot')}>
                <div
                  className="sharebot_button"
                  role="button"
                  onClick={toggleBot}
                >
                  <img alt="" src={chatbotIcon} />
                </div>
              </Tooltip>
            )}

            {showInfoModal && (
              <React.Fragment>
                <Modal
                  style={{ top: 0, minHeight: '100vh' }}
                  visible={showInfoModal}
                  onCancel={toggleInfoModal}
                  footer={null}
                  width="100%"
                  className="info-modal"
                  centered
                >
                  <Informations {...props} onMainMenu={toggleInfoModal} />
                </Modal>
              </React.Fragment>
            )}

            {/* Language Selection */}

            <div id="language_select">
              <Tooltip title={t('v4:selected_language')}>
                <Select
                  size="large"
                  value={lang}
                  onChange={e => handleChangeOption(e)}
                  suffixIcon={null}
                  getPopupContainer={() =>
                    document.getElementById('language_select')
                  }
                >
                  {languages.map(item => (
                    <Option key={item.key} value={item.key}>
                      <div className="ssl-flag-wrap">
                        <Flag
                          code={item.code.includes('en') ? 'us' : item.code}
                        />
                        {item.name}
                      </div>
                    </Option>
                  ))}
                </Select>
              </Tooltip>
            </div>
          </div>
        </div>

        {/* Profile Menus */}
        <div className="author-menu mr-mobile-author-menu">
          <div>
            <Profile
              user={user}
              updateUser={updateUser}
              organizations={organizations}
            />
          </div>
        </div>

        <div className="menu-toggle-wrapper">
          <button
            href="#"
            onClick={() => setShowMenu(!showMenu)}
            className="menu-toggle"
          >
            <span></span>
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>
      </div>
      {/* mobile responsive menu */}

      <div className={showMenu ? 'mr-mobile-menu show-menu' : 'mr-mobile-menu'}>
        <div className="mr-mobile-content">
          <div className="mr-mobile-brand-wrapper">
            <div className="brand">
              <Logo color="white" logo={headerLogo} />
            </div>
            <div
              className="mr-close-wrapper"
              onClick={() => setShowMenu(!showMenu)}
            >
              <button aria-label="Close Menu" className="mr-close">
                <span className="mr-inner"></span>
              </button>
            </div>
          </div>
          {/* <div className="sharelook-line"></div> */}

          <ul className="mr-mobile-item">
            {!isJustSignedIn && (
              <li className="mr-mobile-list-item">
                <div role="button" onClick={handleToggleCenter}>
                  <Icon type="bulb" />
                  <span>
                    {isShowingKnowledgeCenter
                      ? t('v3:learning_center')
                      : t('v3:knowledge_center')}
                  </span>
                </div>
              </li>
            )}

            {!isShowingKnowledgeCenter && (
              <li className="mr-mobile-list-item">
                <div role="button" onClick={toggleBot}>
                  <Icon type="message" />
                  <span>{t('v3:sharebot')}</span>
                </div>
              </li>
            )}
            <li className="mr-mobile-list-item item-btn">
              <div id="mobile_language_select">
                <Select
                  size="large"
                  value={lang}
                  placeholder="Select Language"
                  style={{ width: '165px' }}
                  onChange={e => handleChangeOption(e)}
                  getPopupContainer={() =>
                    document.getElementById('mobile_language_select')
                  }
                >
                  {languages.map(item => (
                    <Option key={item.key} value={item.key}>
                      <Flag code={item.code} height="13" /> {item.name}
                    </Option>
                  ))}
                </Select>
              </div>
            </li>
            <li className="mr-mobile-list-item item-btn">
              <div className="author-menu">
                <div>
                  <Profile
                    user={user}
                    updateUser={updateUser}
                    organizations={organizations}
                  />
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(NewHeaderMain)
